import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import ReactGA from 'react-ga';

class UserRewardHistory extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		data: {
    			activityDetails: [],
                score: ''
    		}	
    	}
    }

    handleActivityFetch = () => {
        let data = Object.assign({}, this.state.data)

        let fetchActivity = `user/activity_details`
        api.getUserResponse(this.props.user.accessToken, fetchActivity)
        .then((result) => {
            if (result.status === 'success') {
                if(result.data !== null){
                    data.activityDetails = result.data.activity_data
                    data.score = result.data.score
                }
                this.setState({data: data})
            }
            
            else {
                this.setState({errorMsg: 'The server encountered an error while fetching. Please try again after sometime.'})
            }
        })
    }

    componentDidMount(){
        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/acitivity_details');
        this.handleActivityFetch()
    }

    render() {
    	let actDetails = this.state.data.activityDetails
    	let activityComponent

        if(Object.keys(actDetails).length >0) {
        	let response_map = new Map(Object.entries(this.state.data.activityDetails))
        	
        	activityComponent = (
                <div>
	                <Grid className="opportunity-list-item">
                        <GridCell span = "12">
                            <Typography> Your Total Chalk Points <b>{this.state.data.score}</b> pts</Typography>
                        </GridCell>
	                    <GridCell span="12">
	                        <Typography use="subtitle1">List of your activities on MyCenta</Typography>
	                    </GridCell>
	                </Grid>
                    
                    {[...response_map].map(function(activityTitle){
                        return (
	                        <Grid className = "opportunity-list-item">
		                        <GridCell span = "12">
			                        <Typography><b>{activityTitle[0]}</b></Typography>
			                        <br />
                                    <br />
			                        {activityTitle[1].map(function(activity){
			                        	let uniqKey = Math.random()
			                            return (
			                            	<div>
			                                	<Card style={{padding: '0px'}} key = {uniqKey}>
			                                		<Grid className="opportunity-list-item">
			                                			<GridCell span="6">
			                                        		<Typography> {activity.reward_name} </Typography>
			                                        	</GridCell>
                                                        <GridCell span="5">
                                                            <Typography> {activity.current_time} </Typography>
                                                        </GridCell>
			                                        	<GridCell span="1">
			                                        		<Typography> {activity.reward} </Typography>
			                                        	</GridCell>
			                                        </Grid>
				                               	</Card>
				                               	<br />
			                               	</div>
			                            )
			                        })}
		                        </GridCell>
	                        </Grid>
	                    )
                    })}
                </div>
            )
        }
        else {
            activityComponent = (
                <div>
                    <Grid className = "opportunity-list-item">
                        <GridCell span = "12">
                            <Card style={{padding: '0px'}}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span="12">
                                        <Typography> You haven't performed any Reward Earning activity. Please check the page for the list of activities.</Typography>
                                    </GridCell>
                                </Grid>
                            </Card>
                        </GridCell>
                    </Grid>
                </div>
            )
        }

        return (
        	<div>
                {activityComponent}
        	</div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRewardHistory);


// WEBPACK FOOTER //
// ./src/views/rewards_user/UserRewardHistory.jsx